import React from "react";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import moment from "moment";
export default function CompanyJob(props) {
  const { sameCompanyJobs } = props;

  return (
    <li>
      <div className="twm-jobs-list-style1 mb-3">
        <div className="twm-media">
          {sameCompanyJobs.imgUrl ? (
            <img src={sameCompanyJobs.imgUrl} alt={sameCompanyJobs.comp_name} />
          ) : (
            <img
              src="/default/default_company_logo.jpg"
              alt={sameCompanyJobs.comp_name}
            />
          )}
        </div>
        <div className="twm-mid-content">
          {sameCompanyJobs.job_title != null ? (
            <Link
              to={`/jobs/${sameCompanyJobs.slug}`}
              className="twm-job-title"
            >
              <h4 className="twm-job-title">
                {sameCompanyJobs.job_title}
                <span className="twm-job-post-duration">
                  / {moment(sameCompanyJobs.created_at).fromNow()}
                </span>
              </h4>
            </Link>
          ) : (
            ""
          )}
          {sameCompanyJobs.job_location != null ? (
            <p className="twm-job-address">{sameCompanyJobs.job_location}</p>
          ) : (
            ""
          )}

          {sameCompanyJobs.experience_type == "N" ? (
            <span className="twm-jobs-type site-text-primary">
              <i className="ri-briefcase-line"></i>No Experience
            </span>
          ) : sameCompanyJobs.experience_type == "F" ? (
            <span className="twm-jobs-type site-text-primary">
              <i className="ri-briefcase-line"></i>Fresher
            </span>
          ) : sameCompanyJobs.experience_type == "E" ? (
            <span className="twm-jobs-type site-text-primary">
              <i className="ri-briefcase-line"></i>
              {sameCompanyJobs.min_exp} 
              {sameCompanyJobs.min_exp_unit === sameCompanyJobs.exp_unit 
                ?  `- ${sameCompanyJobs.max_exp}${sameCompanyJobs.exp_unit}`
                : ` ${sameCompanyJobs.min_exp_unit ? sameCompanyJobs.min_exp_unit : ""} - ${sameCompanyJobs.max_exp} ${sameCompanyJobs.exp_unit}`
              }
            </span>
          ) : (
            ""
          )}

          {sameCompanyJobs.job_type != null ? (
            <span className="twm-job-websites site-text-primary">
              <i className="ri-building-line"></i> {sameCompanyJobs.job_type}
            </span>
          ) : (
            ""
          )}
        </div>
        <div className="twm-right-content">
          {sameCompanyJobs.work_type != null ? (
            <div className="twm-jobs-category green">
              <span className="twm-bg-purple">{sameCompanyJobs.work_type}</span>
            </div>
          ) : (
            ""
          )}
          {sameCompanyJobs.salary_type == "R" ? (
            <div className="twm-jobs-amount">
              {sameCompanyJobs.jobcur} {sameCompanyJobs.minsalary}-
              {sameCompanyJobs.maxsalary}{" "}
              <span>/ {sameCompanyJobs.salary_unit}</span>
            </div>
          ) : sameCompanyJobs.salary_type == "F" ? (
            <div className="twm-jobs-amount">
              {sameCompanyJobs.jobcur} {sameCompanyJobs.minsalary}
              <span>/ {sameCompanyJobs.salary_unit}</span>
            </div>
          ) : sameCompanyJobs.salary_type == "N" ? (
            <div className="twm-jobs-amount">Negotiable</div>
          ) : (
            ""
          )}
          <Link
            to={`/jobs/${sameCompanyJobs.slug}`}
            className="twm-jobs-browse site-text-primary"
          >
            Browse Job
          </Link>
        </div>
      </div>
    </li>
  );
}
